/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Cancel_TitleInputs */

const en_us2_workout_after_cancel_title = /** @type {(inputs: Workout_After_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel this workout?`)
};

const pt_br2_workout_after_cancel_title = /** @type {(inputs: Workout_After_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar este treino?`)
};

const es_419_workout_after_cancel_title = /** @type {(inputs: Workout_After_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cancelar este entrenamiento?`)
};

const pt_pt2_workout_after_cancel_title = /** @type {(inputs: Workout_After_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar este treino?`)
};

const fr_fr2_workout_after_cancel_title = /** @type {(inputs: Workout_After_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler cette séance ?`)
};

const de_de2_workout_after_cancel_title = /** @type {(inputs: Workout_After_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training abbrechen?`)
};

const it_it2_workout_after_cancel_title = /** @type {(inputs: Workout_After_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annullare questo allenamento?`)
};

/**
* | output |
* | --- |
* | "Cancel this workout?" |
*
* @param {Workout_After_Cancel_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_cancel_title = /** @type {((inputs?: Workout_After_Cancel_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Cancel_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_cancel_title(inputs)
	if (locale === "es-419") return es_419_workout_after_cancel_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_cancel_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_cancel_title(inputs)
	if (locale === "de-DE") return de_de2_workout_after_cancel_title(inputs)
	if (locale === "it-IT") return it_it2_workout_after_cancel_title(inputs)
	return en_us2_workout_after_cancel_title(inputs)
});
export { workout_after_cancel_title as "workout-after.cancel_title" }